<template>
  <modal-card ref="modal">
    <h2 class="title is-4">Deactivate Trainer</h2>
    <h6 class="subtitle is-6">Are you sure that you want to deactivate this trainer?</h6>
    <hr/>
    <div class="buttons">
      <button class="button is-primary is-outlined " type="button" @click="closeModel()">Cancel</button>
      <button class="button is-danger is-outlined " @click="handleDeactivateTrainer()">
        Deactivate
      </button>
    </div>
  </modal-card>
</template>

<script>

import { deactivateTrainerMutation } from '../../graphql/trainers'
import ModalCard from '../ModalCard.vue'

export default {
  name: 'DeactivateTrainerModal',
  components: {
    ModalCard
  },
  data () {
    return { }
  },
  props: {
    trainer: Object
  },
  methods: {
    handleDeactivateTrainer () {
      this.$apollo.mutate({
        mutation: deactivateTrainerMutation,
        variables: {
          id: this.trainer.id
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Trainer is Deactivated!',
            type: 'is-success'
          })
          // close modal
          this.$refs.modal.close()
        })
        .catch((e) => {
          this.$toast.open({
            message: 'Failed to deactivate!<br>' + (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
          // close modal
          this.$refs.modal.close()
        })
    },
    closeModel () {
      this.$refs.modal.close()
    }
  }
}
</script>
